const TourJobType = {
  IMMERSIVE_3D_TOUR_PANORAMAS: 0,
  IMMERSIVE_3D_TOUR_PANORAMAS_WITH_FLOOR_PLAN: 1,
};

export default TourJobType;
